import config from 'config';
import { authHeader } from '../_helpers';

export const jobService = {
    logout,
    emailQueryResult,
    getPrintLabelGuid,
    getPrintLabelFormats,
    GetDeliveryTrackingByGuid
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('token');
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                if(response.url !== `${config.apiUrl}/auth/login`)
                    location.reload(true);
            }

            const error = (data && data.message) || response.status;
            return Promise.reject(error);
        }

        return data;
    });
}

function emailQueryResult(data) {

    var headers = authHeader();
    headers['Content-Type'] = 'application/json';

    const requestOptions = {
        crossDomain: true,
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
    }

    var url = new URL(`${config.apiUrl}/jobs/JobQuery/Email`);
    return fetch(url, requestOptions).then(handleResponse);
}

function getPrintLabelGuid(jobId, dropNumber) {
    
    var headers = authHeader();

    const requestOptions = {
        method: 'GET',
        headers: headers
    }
    
    var url = new URL(`${config.apiUrl}/jobs/${jobId}/print`);
    
    if (dropNumber)
    {
        url.searchParams.set('drop_number', dropNumber);
    }

    return fetch(url, requestOptions).then(handleResponse);
}

function getPrintLabelFormats() {

    var headers = authHeader();

    const requestOptions = {
        method: 'GET',
        headers: headers
    }
    
    var url = new URL(`${config.apiUrl}/print_label_format`);

    return fetch(url, requestOptions).then(handleResponse);
}

function GetDeliveryTrackingByGuid(guid) {

    var headers = authHeader();

    const requestOptions = {
        method: 'GET',
        headers: headers
    }
    
    var url = new URL(`${config.apiUrl}/jobs/delivery_tracking/${guid}`);

    return fetch(url, requestOptions).then(handleResponse);
}
